import { PsDate } from '../../../shared/model/PsDate';

export class PsWork {

    _id; // number
    _code; // string
    _name; // string
    _startDate; // Date
    _endDate; // Date

    constructor(
        id,
        code,
        name,
        startDate,
        endDate,
    ) {
        this._id = id;
        this._code = code;
        this._name = name;
        this._startDate = startDate;
        this._endDate = endDate;
    }

    static null() {
        return new this(
            -1,
            '',
            '',
            PsDate.fromNow(),
            PsDate.fromNow(),
        );
    }

    static arrayFromBackend(constructionSites) {
        return constructionSites.map((cs) => PsWork.fromBackend(cs));
    }

    static fromBackend(constructionSite) {
        return new this(
            constructionSite.id,
            constructionSite.code,
            constructionSite.name,
            PsDate.fromDate(constructionSite.start_date),
            constructionSite.end_date ? PsDate.fromDate(constructionSite.end_date) : undefined,
        );
    }

    id() {
        return this._id;
    }

    code() {
        return this._code;
    }

    name() {
        return this._name;
    }

    description() {
        return `${this.code()} - ${this.name()}`
    }

    startDate() {
        return this._startDate;
    }

    startDateString() {
        return this.startDate().toDateString();
    }

    endDate() {
        return this._endDate;
    }

    endDateString() {
        return this.endDate() ? this.endDate().toDateString() : '';
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/PsWork.js